import type { breakpointsConfig } from '@ui/breakpoints/breakpoints.config';
import type { style } from '@vanilla-extract/css';

export type StyleSelectors = Exclude<Extract<Parameters<typeof style>[0], { selectors?: unknown }>['selectors'], undefined>;

// We decied to call this c instead of classes because it's in every single component. Same logic as _ for lodash and $ for jquerry.
export function c(...args: (string | undefined | false)[]) {
    let output = '';
    // Yes it looks weird and cold be simple .join() but performance wise x5 faster this way and used everywhere on runtime.
    for (let i = 0; i < args.length; i++) {
        const string = args[i];
        if (string) {
            if (output) output += ' ';
            output += string;
        }
    }
    return output;
}

export function transition(transitionNames: string[], duration: string) {
    return transitionNames.map((t) => `${t} ${duration}`).join(',');
}

export function mediaSelector(breakpoint: keyof (typeof breakpointsConfig)['width'], selector: string = '&') {
    return `.${breakpoint} ${selector}`;
}

export function getCssVarName(cssVar: string) {
    return cssVar.slice(4, -1);
}
